import * as React from "react";
import { useEffect } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { Link, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";

import { updateAppConfigRecord } from "../../../services/application-config";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

function AddApplicationConfig(props) {
  const appConfigsDataId = useSelector((state) => state.appConfigsData);
  const { single: AppConfigsDataItem } = appConfigsDataId;
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const navigate = useNavigate();

  useEffect(() => {
    if (AppConfigsDataItem.data) {
      reset({
        key: "",
        value: "",
      });
    }
  }, [AppConfigsDataItem]);

  const updateAppConfigs = (data) => {
    const buttonType = window.event.submitter.name;

    if (buttonType === "save") {
      updateAppConfigRecord({
        id: null,
        key: data.key,
        value: data.value,
      })
        .then((response) => {})
        .catch((error) => {
          throw error;
        });
      navigate("/app/list-app-config");
    }
    if (buttonType === "savegoanother") {
      updateAppConfigRecord({
        id: null,
        key: data.key,
        value: data.value,
      })
        .then((response) => {
          navigate("/app/app-config/0");
          reset({
            key: "",
            value: "",
          });
        })
        .catch((error) => {
          throw error;
        });
    }
    if (buttonType === "savecontinue") {
      updateAppConfigRecord({
        id: null,
        key: data.key,
        value: data.value,
      })
        .then((response) => {
          const ids = response.id;
          navigate(`/app/app-config/${ids}`);
        })
        .catch((error) => {
          throw error;
        });
    }
  };

  return (
    <>
      <Box sx={{ ml: "4", pt: "14 !important", pb: "5", px: 3 }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginBottom: "25px",
            marginTop: "20px",
            gap: "16px",
          }}
        >
          <Link to="/app/list-app-config">
            <ArrowBackIcon
              fontSize="large"
              l
              color="secondary"
              sx={{ background: "#040721", p: 1, borderRadius: "50%" }}
            />
          </Link>
          <Typography
            variant="h5"
            component="h5"
            fontWeight={"bold"}
            color={"#3d3d3d"}
          >
            Add Application Configuration
          </Typography>
        </div>
        <Box sx={{ background: "#ffffff", p: 2, mb: 4, pb: 4 }}>
          <form onSubmit={handleSubmit(updateAppConfigs)}>
            <div className="row">
              <div className="col-md-7">
                <div className="form-group">
                  <label
                    className="form-label fw-bold text-secondary user-select-none"
                    htmlFor="key"
                  >
                    Key: <small className="text-danger fs-6">*</small>
                  </label>
                  <input
                    {...register("key", { required: true })}
                    className={`form-control ${
                      errors.key && "invalid-form-input"
                    }`}
                    type="text"
                    id="key"
                  />
                </div>
              </div>
              <div className="col-md-7">
                <div className="form-group">
                  <label
                    className="form-label fw-bold text-secondary user-select-none"
                    htmlFor="value"
                  >
                    Value: <small className="text-danger fs-6">*</small>
                  </label>
                  <input
                    {...register("value", { required: true })}
                    className={`form-control ${
                      errors.value && "invalid-form-input"
                    }`}
                    type="text"
                    id="value"
                  />
                </div>
              </div>
            </div>
            <hr style={{ height: "0.5px", marginTop: "32px" }} />
            <div>
              <button
                type="submit"
                className="btn btn-primary py-2 px-5"
                name="save"
                variant="contained"
                sx={{ width: "25%" }}
              >
                Save
              </button>
              <button
                variant="contained"
                type="submit"
                className="btn btn-primary py-2 px-5"
                name="savegoanother"
                sx={{ width: "25%" }}
              >
                Save And Add Another
              </button>
              <button
                variant="contained"
                type="submit"
                className="btn btn-primary py-2 px-5"
                name="savecontinue"
                sx={{ width: "25%" }}
              >
                Save and Continue Editing
              </button>
            </div>
          </form>
        </Box>
      </Box>
    </>
  );
}

export default AddApplicationConfig;
